import { useQuery } from "@tanstack/react-query";

import { ConsentsApi } from "../api/consentsApi";

export const ConsentsQueryKeys = {
  all: ["consents"] as const,
  pending: () => [...ConsentsQueryKeys.all, "pending"] as const,
};

export const usePendingConsentsQuery = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ConsentsQueryKeys.pending(),
    queryFn: () => ConsentsApi.getPendingConsents(),
    enabled,
  });
};
